export default __webpack_public_path__ + "static/media/save.f85794c1.png";